<template>
  <div class="row">
    <h3 class="col-12">{{titulo}}</h3>
    <div class="form-group col-12">
      <label for="direccion">Dirección</label>
      <span v-if="errors.direccion && touched.direccion" class="formError">{{ errors.direccion }}</span>
      <input
        @input="onChange"
        @blur="handleTouched"
        name="ship-address"
        type="text"
        id="direccion"
        v-model="form.direccion"
        class="form-control"
        :autocomplete="autocomplete ? 'shipping street-address' : 'off'"
        required
      />
    </div>
    <div class="form-group col-md-3">
      <label for="piso">Piso</label>
      <input @input="onChange" type="text" id="piso" v-model="form.piso" class="form-control" />
    </div>
    <div class="form-group col-md-3">
      <label for="departamento">Departamento</label>
      <input
        @input="onChange"
        type="text"
        id="departamento"
        v-model="form.departamento"
        class="form-control"
      />
    </div>
    <div class="form-group col-md-6">
      <label for="codigoPostal">Codigo Postal</label>
      <span v-if="errors.codigoPostal && touched.codigoPostal" class="formError">{{ errors.codigoPostal }}</span>
      <input
        @input="onChange"
        @blur="handleTouched"
        type="text"
        name="ship-zip"
        id="codigoPostal"
        v-model="form.codigoPostal"
        class="form-control"
        :autocomplete="autocomplete ? 'shipping postal-code' : 'off'"
        required
      />
    </div>
    <div class="form-group col-md-6">
      <label for="ciudad">Ciudad</label>
      <span v-if="errors.ciudad && touched.ciudad" class="formError">{{ errors.ciudad }}</span>
      <input
        @input="onChange"
        @blur="handleTouched"
        name="ship-city"
        type="text"
        id="ciudad"
        v-model="form.ciudad"
        class="form-control"
        :autocomplete="autocomplete ? 'shipping locality' : 'off'"
        required
      />
    </div>
    <div class="form-group col-md-6">
      <label for="provincia">Provincia</label>
      <span v-if="errors.provincia && touched.provincia" class="formError">{{ errors.provincia }}</span>
      <input
        @input="onChange"
        @blur="handleTouched"
        name="ship-state"
        type="text"
        id="provincia"
        v-model="form.provincia"
        class="form-control"
        :autocomplete="autocomplete ? 'shipping region' : 'off'"
        required
      />
    </div>
  </div>
</template>
<script>
import {errorMessages,validateRequiredFields} from '../../constants'
export default {
  props: ["domicilio", "titulo", "autocomplete"],
  model: {
    prop: "domicilio",
    event: "change",
  },
  data() {
    return {
      form:{
        direccion: "",
        departamento: "",
        piso: "",
        codigoPostal: "",
        provincia: "",
        ciudad: "",
        isValid:true,
      },
      errors: {
        direccion: errorMessages.required,
        codigoPostal: errorMessages.required,
        provincia: errorMessages.required,
        ciudad: errorMessages.required,
      },
      touched:{
        direccion:false,
        codigoPostal:false,
        provincia:false,
        ciudad:false,
      },
    };
  },

  methods: {
    validate(){
      this.errors= {
        direccion: "",
        codigoPostal: "",
        provincia: "",
        ciudad: "",
      };

      validateRequiredFields(['direccion','codigoPostal','ciudad','provincia'],this.form,this.errors)
      let noErrors=true
      Object.keys(this.errors).map((key)=>{
        if (this.errors[key]){
          noErrors=false;
        }
      }
      )
      this.form.isValid=noErrors
    },
    handleTouched(e){
      this.touched[e.target.id]=true
    },
    onChange() {
      this.validate()
      this.$emit("change", this.form);
    },
  },
};
</script>